type BonusesTypes =
  | 'deposit'
  | 'cashbonus'
  | 'freespin'
  | 'freebet'
  | 'reload'
  | 'cashback'
  | 'rakeBack'
  | 'tournament'

export function useHighlightBonuses() {
  const highlightedBonuses = useRouteQuery<BonusesTypes | null>(
    'highlightBonus',
    null,
  )

  return {
    highlightedBonuses,
  }
}
